{
  "formTitle": "적 rally 등록",
  "formWhy": "인게임에서 지금 읽히는 숫자를 그대로 넣습니다. 시각은 서버가 찍습니다.",
  "formEnemy": "적 roster",
  "formEnemyPick": "고르세요",
  "formEnemyEmpty": "명부에 적이 없습니다",
  "formEnemyOnlyRoster": "여기서는 새 적을 만들 수 없습니다. roster 탭의 명부에서 올립니다.",
  "formPhase": "지금 어느 단계인가",
  "formPhaseRallying": "rallying 중",
  "formPhaseMarching": "행군 중",
  "formPhaseWhy": "같은 0:52 가 단계마다 다른 뜻입니다. rallying 이면 아직 안 떴고, 행군이면 이미 날아오는 중입니다.",
  "formRemaining": "그 순간의 남은 시간",
  "formSubmit": "적 rally 올리기",
  "formNeedEnemy": "적을 고르세요.",
  "formAdded": "올렸습니다. 목록 맨 아래에 섭니다. 자리는 등록한 순서대로 고정입니다.",
  "formAnchorWhy": "확정하는 순간을 서버가 앵커로 찍습니다. CT 는 시계를 읽어 적을 필요가 없습니다.",

  "composeTitle": "defense",
  "composeTitleHint": "적 rally 시퀀스",
  "composeWhy": "등록한 순서 그대로 섭니다. 착탄과 남은 시간은 줄 안에서 흐르고, 다시 앵커해도 자리는 바뀌지 않습니다.",
  "composeEmpty": "등록된 적 rally 가 없습니다.",
  "composeNextRegister": "다음: 왼쪽 폼에서 적 rally 를 하나 올립니다.",
  "composeNextWatch": "다음: 인게임 숫자가 달라지면 그 줄을 다시 앵커합니다.",
  "composeSignalOwner": "진행 중인 signal: {roster}, 개시까지 {remaining}",
  "composeSignalPassed": "지나간 signal: {roster}, 개시 지남 {remaining}",
  "composeSignalMuted": "진행 중인 signal: {roster}, 개시까지 {remaining}. 소리는 껐습니다",
  "composeSignalPassedMuted": "지나간 signal: {roster}, 개시 지남 {remaining}. 소리는 꺼져 있었습니다",
  "composeSignalPassedRang": "지나간 signal: {roster}, 개시 지남 {remaining}. 소리는 제때 울렸습니다",
  "composeSignalPassedMissed": "지나간 signal: {roster}, 개시 지남 {remaining}. 소리는 울리지 않았습니다",
  "composeSignalNone": "진행 중인 signal 이 없습니다.",

  "rowImpact": "착탄",
  "rowRallyingLeft": "rallying 남음",
  "rowImpactLeft": "착탄까지",
  "rowImpactPassed": "착탄 지남",
  "rowAnchoredRallying": "rallying 앵커",
  "rowAnchoredMarching": "행군 앵커",
  "rowEnemyGone": "명부에서 내려간 적",
  "rowReanchor": "다시 앵커",
  "rowReanchorWhy": "지금 화면에 뜬 숫자를 다시 넣습니다. 그 순간이 새 기준이 됩니다.",
  "rowReanchorDone": "다시 앵커했습니다. 이 줄의 착탄과 대응이 함께 다시 섰고 자리는 그대로입니다.",
  "rowRemove": "삭제",
  "rowRemoveArmed": "한 번 더 누르면 지웁니다",
  "rowRemoveWhat": "이 관측 한 줄이 사라지고 이 rally 에 걸린 대응도 함께 사라집니다.",
  "rowCancel": "취소",

  "unknownBand": "착탄 미상 (입력필요)",
  "unknownWhy": "명부에 이 적의 행군이 없어 착탄을 계산할 수 없습니다. 계산된 줄과 섞지 않으려고 맨 아래 띠에 둡니다.",
  "unknownFix": "roster 탭 명부에 그 적의 행군을 넣으면 등록 순서의 제자리로 들어갑니다. 행군 단계로 다시 앵커해도 됩니다.",

  "viewTitle": "수비",
  "viewTitleHint": "내가 보낼 시점",
  "viewWhy": "트리거는 인게임 카운트다운의 기준값이고, T− 는 그 순간까지 앱이 세는 시간입니다.",
  "viewEmpty": "등록된 적 rally 가 없습니다. CT 가 올리면 여기에 섭니다.",
  "viewNextImpact": "다음 착탄까지",
  "viewNoSound": "수비에는 signal 이 없습니다. 화면의 트리거를 보고 보냅니다.",
  "viewNoSoundWithAttack": "수비에는 signal 이 없습니다. 지금 울릴 소리는 위에 적힌 attack signal 입니다.",

  "sectionNext": "다음 트리거",
  "sectionNone": "보낼 대응 없음",
  "cellTrigger": "트리거",
  "cellCountdown": "보낼 때까지",
  "cellImpossible": "불가",
  "cellImpossibleWhy": "보낼 시점이 지났습니다.",
  "cellLateBy": "지난 폭",
  "cellUnknown": "착탄 미상",
  "cellUnknownWhy": "아직 판정할 수 없습니다.",
  "dimAllImpossible": "전 rally 불가",
  "dimAllImpossibleWhy": "행군 {marching} 이 모든 대응보다 깁니다.",
  "dimNothing": "지금 보낼 수 있는 대응이 없습니다",
  "dimMarchingMissing": "행군 입력필요",
  "dimMarchingMissingWhy": "roster 탭 명부에서 넣습니다.",
  "dimWhy": "숨기지 않습니다. 이 사람이 못 간다는 사실이 CT 가 배정을 바꿀 근거입니다.",

  "guideTitle": "R 과 M 이 무엇인가",
  "guideRallying": "= 적이 아직 rallying 중일 때 보냅니다. 칩의 숫자는 보내는 순간 적 rally 의 남은 rallying 입니다.",
  "guideMarching": "= 적이 이미 행군 중일 때 보냅니다. 칩의 숫자는 보내는 순간 적 rally 의 착탄까지 남은 시간입니다.",
  "guideOrder": "이름은 명부 순서 그대로이고 시간이 흘러도 자리가 바뀌지 않습니다. 각 이름 안의 줄은 보낼 순서대로이고, 지난 줄은 흐려질 뿐 자리를 지킵니다.",

  "tabAttack": "attack 보기",
  "tabDefense": "defense 보기",
  "tabWhy": "둘은 동시에 살아 있습니다. 탭을 옮겨도 예약된 소리는 걷히지 않습니다.",
  "presenceHandle": "접속 {n}명",
  "presenceHandleStale": "연결 없음",
  "attackWaiting": "confirm 한 attack ops 가 있습니다 (rally {n}줄). 자기 rally 는 attack 보기에서 고릅니다.",
  "attackWaitingGo": "attack 보기로",

  "triggerRallying": "R",
  "triggerMarching": "M"
}
